import { TFunction } from "i18next";

export const CLASS_SECTION_OPTIONS = (t?: TFunction) => [
  { label: t ? t("preschool") : "Preschool", value: "preschool" },
  { label: t ? t("primary") : "Primary", value: "primary" },
  { label: t ? t("secondary") : "Secondary", value: "secondary" },
  { label: t ? t("high_school") : "High School", value: "highSchool" },
];

export const CLASS_SECTION_OPTIONS_BY_LEVEL = ( t?: TFunction) => [
  { label: t ? t("preschool") : "Preschool", value: "preschool" },
  { label: t ? t("primary_school") : "Primary", value: "primary_school" },
  { label: t ? t("secondary_school") : "Secondary", value: "secondary_school" },
  { label: t ? t("high_school") : "High School", value: "high_school" }
];  

export const CLASS_LEVEL_OPTIONS = (section: string, t?: TFunction) => {
  const levelsBySection: Record<string, { label: string; value: string }[]> = {
    preschool: [
      { label: t ? t("level_1") : "Level 1", value: "level1" },
      { label: t ? t("level_2") : "Level 2", value: "level2" },
      { label: t ? t("level_3") : "Level 3", value: "level3" },
    ],
    primary: [
      { label: t ? t("grade_1") : "Grade 1", value: "grade1" },
      { label: t ? t("grade_2") : "Grade 2", value: "grade2" },
      { label: t ? t("grade_3") : "Grade 3", value: "grade3" },
      { label: t ? t("grade_4") : "Grade 4", value: "grade4" },
      { label: t ? t("grade_5") : "Grade 5", value: "grade5" },
      { label: t ? t("grade_6") : "Grade 6", value: "grade6" },
    ],
    secondary: [
      { label: t ? t("secondary_1") : "Secondary 1", value: "secondary1" },
      { label: t ? t("secondary_2") : "Secondary 2", value: "secondary2" },
      { label: t ? t("secondary_3") : "Secondary 3", value: "secondary3" },
    ],
    highSchool: [
      { label: t ? t("high_school_1") : "High School 1", value: "hs1" },
      { label: t ? t("high_school_2") : "High School 2", value: "hs2" },
      { label: t ? t("high_school_3") : "High School 3", value: "hs3" },
    ],
  };

  return levelsBySection[section] || [];
};
